import React from "react"
import SvgIcon from "@material-ui/core/SvgIcon"

export default function FluxIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 256 102">
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M205.033 0a50.722 50.722 0 0 0-27.301 7.939l-49.733 36.526-26.214-19.25c-1.58 2.564-3.17 5.112-4.692 7.75-.367.635-.707 1.278-1.068 1.912l21.911 16.09-45.978 33.762a39.626 39.626 0 0 1-20.994 6.005c-21.926 0-39.767-17.839-39.767-39.767 0-21.929 17.838-39.767 39.767-39.767a39.593 39.593 0 0 1 20.994 6.004l4.57 3.354c1.889-3.264 3.846-6.452 5.822-9.617l-4.085-3A50.69 50.69 0 0 0 50.964.004C22.819.003 0 22.822 0 50.967s22.816 50.963 50.964 50.963c10.048 0 19.409-2.92 27.301-7.938L128 57.468l26.315 19.325c1.612-2.641 3.22-5.291 4.811-8.052.315-.547.6-1.09.911-1.638l-21.972-16.136 45.975-33.763a39.634 39.634 0 0 1 20.994-6.004c21.929 0 39.767 17.838 39.767 39.767 0 21.928-17.838 39.767-39.767 39.767a39.6 39.6 0 0 1-20.994-6.005l-4.504-3.307a406.479 406.479 0 0 1-5.78 9.646l3.98 2.92a50.697 50.697 0 0 0 27.301 7.94c28.145 0 50.964-22.82 50.964-50.964C255.997 22.819 233.181 0 205.033 0z"
      />
    </SvgIcon>
  )
}
